import { Button } from "antd";
import React from "react";
import { ReactComponent as ArrowRight } from "../../../../../assets/images/icon/backToTop.svg";
const BannerContent: React.FC<any> = () => {
    // const ContactBtn = () =>{

    // }
    return (
        <div className="bannerContent">
            <h1>
                <div className="subTitle">Capture </div>
                <span className="mainTitle">
                    Leads
                </span> 10X Faster
            </h1>
            <p className="bannerPera">Effortless Lead Catpure for Busy Exhibitors</p>
            <div className="bannerBtn">
                <Button className="commanBtn" >
                    <span className="arrowIcon">
                        <ArrowRight />
                    </span>
                    <span className="beforeIcon"></span>
                    <a href="#contactus">

                        Contact us
                    </a>
                </Button>
            </div>
        </div>
    );
};

export default BannerContent;
